// NYAYYAKSHA Motion OS — Judicial Precision
// Single source of truth for all animation. Components must consume these
// tokens rather than inventing their own durations or easings.

export const DURATION = {
  instant: 0.08,
  fast: 0.14,
  normal: 0.22,
  deliberate: 0.32,
  reveal: 0.42,
};

export const EASE = {
  standard: [0.22, 1, 0.36, 1],
  enter: [0.16, 1, 0.3, 1],
  exit: [0.4, 0, 1, 1],
  emphasized: [0.2, 0.8, 0.2, 1],
};

export const SPRING = {
  micro: { type: "spring", stiffness: 520, damping: 34, mass: 0.6 },
  control: { type: "spring", stiffness: 380, damping: 32, mass: 0.8 },
  panel: { type: "spring", stiffness: 260, damping: 30, mass: 0.9 },
};

// Restrained page transition — ~180-260ms, transform + opacity only.
export const pageVariants = {
  initial: { opacity: 0, y: 7, scale: 0.998 },
  enter: { opacity: 1, y: 0, scale: 1 },
  exit: { opacity: 0, y: -3 },
};

// Button microstate choreography.
export const buttonMotion = {
  rest: { y: 0, scale: 1 },
  hover: { y: -1 },
  tap: { y: 0, scale: 0.975 },
};
